import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'

import { StaffReminder } from '../../lib/types/models/staff/staff-reminder'

const StaffRemindersCell = ({
  reminders,
  wrap = false
}: {
  reminders?: StaffReminder[]
  /** In a narrow column, lets each badge break after the dash, on 2 lines */
  wrap?: boolean
}) => {
  if (!reminders || reminders.length === 0) return '-'

  return (
    <div className="flex flex-col gap-1 py-2">
      {reminders.map((reminder) => (
        <Badge
          key={`${reminder.index}-${String(reminder.sentAt)}`}
          variant={reminder.isFinal ? 'danger' : 'grey'}
          text={`R${reminder.index}${wrap ? '\u00A0' : ' '}- ${DateFormatter.DDMMYYYY(reminder.sentAt)}`}
          className={wrap ? 'h-auto min-h-7 py-1 whitespace-normal' : undefined}
        />
      ))}
    </div>
  )
}

export default StaffRemindersCell
